// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { PersesColor } from './types';

export const green: PersesColor = {
  50: '#EAF9F1',
  100: '#D5F2E3',
  150: '#C1ECD4',
  200: '#ACE5C6',
  300: '#82D9AA',
  400: '#59CC8D',
  500: '#2FBF71',
  600: '#26995A',
  700: '#1C7344',
  800: '#134C2D',
  850: '#0E3922',
  900: '#092617',
  950: '#05130B',
};
